export enum SubmissionType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  INTERNALLY_REJECT = 'INTERNALLY_REJECT',
}
